var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMarketplaceWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 28H28",
    stroke: "#F3F4F6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.33333V10.6667C4 11.7275 4.42143 12.7449 5.17157 13.4951C5.92172 14.2452 6.93913 14.6667 8 14.6667C9.06087 14.6667 10.0783 14.2452 10.8284 13.4951C11.5786 12.7449 12 11.7275 12 10.6667V9.33333M12 10.6667C12 11.7275 12.4214 12.7449 13.1716 13.4951C13.9217 14.2452 14.9391 14.6667 16 14.6667C17.0609 14.6667 18.0783 14.2452 18.8284 13.4951C19.5786 12.7449 20 11.7275 20 10.6667V9.33333M20 10.6667C20 11.7275 20.4214 12.7449 21.1716 13.4951C21.9217 14.2452 22.9391 14.6667 24 14.6667C25.0609 14.6667 26.0783 14.2452 26.8284 13.4951C27.5786 12.7449 28 11.7275 28 10.6667V9.33333H4L6.66667 4H25.3333L28 9.33333",
    stroke: "#F3F4F6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 28V14.4667",
    stroke: "#F3F4F6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 28V14.4667",
    stroke: "#F3F4F6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 28V22.6667C12 21.9594 12.281 21.2811 12.781 20.781C13.2811 20.281 13.9594 20 14.6667 20H17.3333C18.0406 20 18.7189 20.281 19.219 20.781C19.719 21.2811 20 21.9594 20 22.6667V28",
    stroke: "#F3F4F6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarketplaceWhite);
export default __webpack_public_path__ + "static/media/Icon_Marketplace_White.f7d341e1adfc95f3491b5b133fd389b4.svg";
export { ForwardRef as ReactComponent };